import script from "./ReportIssueDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportIssueDialog.vue?vue&type=script&setup=true&lang=js"

import "./ReportIssueDialog.vue?vue&type=style&index=0&id=4b3d0dae&lang=scss&scoped=true"
import "./ReportIssueDialog.vue?vue&type=style&index=1&id=4b3d0dae&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3d0dae"]])

export default __exports__